<template>
  <div class="animated fadeIn">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />

    <b-row>
      <b-col sm="6" lg="4">
        <b-card no-body class="cardClientes">
          <b-card-body class="pb-0">
            <b-dropdown
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
            >
              <template slot="button-content">
                <i class="fa fa-plus-square" style="font-size: 24px"></i>
              </template>
              <b-dropdown-item @click="enviarpush">Enviar push</b-dropdown-item>
              <b-dropdown-item @click="visualizarclientes"
                >Visualizar clientes</b-dropdown-item
              >
            </b-dropdown>
            <h4 class="mb-0">{{ clientesCadastrados }}</h4>
            <p>Clientes cadastrados</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="4">
        <b-card no-body class="cardSorteios">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ sorteiosAtivos }}</h4>
            <p>Sorteios ativos</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="4">
        <b-card no-body class="cardPromocoes">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ promocoesAtivas }}</h4>
            <p>Promoções ativas</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="4">
        <b-card no-body class="cardEnv">
          <b-card-body class="pb-0">
            <b-dropdown
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
            >
              <template slot="button-content">
                <i class="fa fa-plus-square" style="font-size: 24px"></i>
              </template>
              <b-dropdown-item @click="enviarpush"
                >Visualizar envios</b-dropdown-item
              >
              <b-dropdown-item @click="comprarpacotes"
                >Comprar pacotes</b-dropdown-item
              >
            </b-dropdown>
            <h4 class="mb-0">{{ pushsEnviados }}</h4>
            <p>Pushs enviados</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="4">
        <b-card no-body class="cardEnvCamp">
          <b-card-body class="pb-0">
            <b-dropdown
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
            >
            </b-dropdown>
            <h4 class="mb-0">{{ pushsCampanhas }}</h4>
            <p>Pushs de campanhas</p>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col sm="6" lg="4">
        <b-card no-body class="cardEnvCup">
          <b-card-body class="pb-0">
            <b-dropdown
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
            >
            </b-dropdown>
            <h4 class="mb-0">{{ pushsCupons }}</h4>
            <p>Pushs de cupons</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card no-body class="mt-2">
          <b-tabs pills card>
            <b-tab title="Filtros">
              <b-row>
                <b-col xl="6" lg="6" md="6" sm="12">
                  <b-input-group prepend="Data Inicial" class="date-input">
                    <datepicker
                      class="form-control"
                      placeholder="Escolha a data"
                      v-model="datainicial"
                      :language="ptBR"
                      :format="customFormatter"
                      :disabledDates="disabledDatesStart"
                      :key="disabledDatesStart != null"
                      @selected="mudaDataInicial"
                    ></datepicker>
                  </b-input-group>
                </b-col>
                <b-col xl="6" lg="6" md="6" sm="12">
                  <b-input-group prepend="Data Final" class="date-input">
                    <datepicker
                      class="form-control"
                      placeholder="Escolha a data"
                      v-model="datafinal"
                      :language="ptBR"
                      :format="customFormatter"
                      @selected="mudaDataFinal"
                      :disabledDates="disabledDatesEnd"
                      :key="disabledDatesEnd != null"
                    ></datepicker>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col xl="6" lg="6" md="12" sm="12">
        <b-card header="Clientes por interesse" class="mt-2">
          <clientes-por-interesse></clientes-por-interesse>
        </b-card>
      </b-col>
      <b-col xl="6" lg="6" md="12" sm="12">
        <b-card class="mt-2">
          <template slot="header"
            >Detalhamento por caixa -
            {{ moment(datainicial).format("DD/MM/YY") }} a
            {{ moment(datafinal).format("DD/MM/YY") }}</template
          >
          <ticket-medio-por-caixa
            :datainicial="datainicial"
            :datafinal="datafinal"
          ></ticket-medio-por-caixa>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col xl="12" lg="12" md="12" sm="12">
        <b-card class="mt-2">
          <template slot="header"
            >Formas de pagamento mais utilizadas -
            {{ moment(datainicial).format("DD/MM/YY") }} a
            {{ moment(datafinal).format("DD/MM/YY") }}</template
          >
          <formas-de-pagamento
            :datainicial="datainicial"
            :datafinal="datafinal"
          ></formas-de-pagamento>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import ClientesPorInteresse from "./charts/ClientesPorInteresse";
import TicketMedioPorCaixa from "./charts/TicketMedioPorCaixa";
import FormasDePagamento from "./charts/FormasDePagamento";
import axios from "axios";
import Loading from "vue-loading-overlay";

import * as config from "@/config.json";
import moment from "moment";

export default {
  name: "dashboard",
  components: {
    Datepicker,
    ClientesPorInteresse,
    TicketMedioPorCaixa,
    FormasDePagamento,
    Loading,
    moment,
  },
  data: function () {
    return {
      selected: "Month",
      clientesCadastrados: null,
      pushsEnviados: null,
      pushsCampanhas: null,
      pushsCupons: null,
      promocoesAtivas: null,
      sorteiosAtivos: null,
      isLoading: false,
      datainicial: null,
      datafinal: null,
      ptBR: ptBR,
      disabledDatesStart: null,
      disabledDatesEnd: null,
      dataIni: null,
      dataFim: null,
    };
  },
  methods: {
    enviarpush() {
      this.$router.push("/campanhas/");
    },
    visualizarclientes() {
      this.$router.push("/clientes");
    },
    comprarpacotes() {
      this.$router.push("/pacotes");
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    formatDate(dataIni, dataFim) {
      this.datainicial = moment(dataIni).format("YYYY-MM-DD 00:00:00");
      this.datafinal = moment(dataFim).format("YYYY-MM-DD 23:59:59");
    },

    
    mudaDataFinal(data) {
      if (data) {
        this.disabledDatesStart = null;
        this.disabledDatesStart = {};
        this.disabledDatesStart.from = new Date(data);
      }
    },
    mudaDataInicial(data) {
      if (data) {
        this.disabledDatesEnd = null;
        this.disabledDatesEnd = {};
        this.disabledDatesEnd.to = new Date(data);
      }
    },

    async getTotalizadores() {
      const url = `${
        config.default.servidor
      }/gerencial/retorna-totalizadores/${localStorage
        .getItem("enterprise_id")
        .toString()}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: `${config.default.authorizationBasic}` },
        });

        if (response.status == 200) {
          this.clientesCadastrados = response.data.data.qtdRegistrados;
          this.pushsEnviados = response.data.data.qtdPushs;
          this.promocoesAtivas = response.data.data.qtdPromocoesAtivas;
          this.sorteiosAtivos = response.data.data.qtdSorteiosAtivos;
          this.pushsCampanhas = response.data.data.qtdPushsCampanhas;
          this.pushsCupons = response.data.data.qtdPushsCupons;
          this.isLoading = false;
        }
      } catch (error) {
        console.log({ error });
        this.isLoading = false;
      }
    },
  },

  async beforeMount() {
    localStorage.removeItem("datainicial");
    localStorage.removeItem("datafinal");
    localStorage.removeItem("qtdCampanhas");
    this.isLoading = true;
    this.datainicial = moment().startOf("month").format("YYYY-MM-DD hh:mm");
    this.datafinal = new moment()
      .add(1, "months")
      .date(1)
      .format("YYYY-MM-DD hh:mm");
    this.disabledDatesStart = {};
    this.disabledDatesStart.from = new Date(this.datafinal);

    this.disabledDatesEnd = {};
    this.disabledDatesEnd.to = new Date(this.datainicial);

    await this.getTotalizadores();
  },
};
</script>

<style scoped>
.cardClientes {
  font-weight: 400;
  color: white;
  background-color: #393a39;
}

.cardSorteios {
  font-weight: 400;
  color: white;
  background-color: #1594a5;
}

.cardPromocoes {
  font-weight: 400;
  color: white;
  background-color: #4ea4b0;
}

.cardEnv {
  font-weight: 400;
  color: white;
  background-color: #02905a;
}

.cardEnvCamp {
  font-weight: 400;
  color: white;
  background-color: #498f74;
}

.cardEnvCup {
  font-weight: 400;
  color: white;
  background-color: #498f74;
}
</style>